import { prettyToTagMap, tagToPrettyMap } from '../MergeTagOptions';
import { MERGE_TAG_REGEX } from '../quill_input/mergeTagQuillParser';

const MIXED_TAG_REGEX = /\{\{\{"value":"([^"]+)"\}\}\}/;
const MIXED_TAG_REGEX_GLOBAL = new RegExp(MIXED_TAG_REGEX.source, 'g');

export const parser = () => {
  const parse = (text?: string) => {
    if (!text) return '';

    return text.replace(MERGE_TAG_REGEX, tag => {
      const prettyTag = tagToPrettyMap.get(tag) ?? tag;
      return `{{${prettyTag}}}`;
    });
  };

  const serialize = (text?: string) => {
    if (!text) return '';

    return text
      .replace(MIXED_TAG_REGEX_GLOBAL, mixedTag => {
        const pretty = mixedTag.match(MIXED_TAG_REGEX);
        if (!pretty) return '';

        const mergeTag = prettyToTagMap.get(pretty[1]);
        return mergeTag ?? '';
      })
      .trim();
  };

  return { parse, serialize };
};
